import { render, staticRenderFns } from "./ReceptionSelector.vue?vue&type=template&id=cb562c30"
import script from "./ReceptionSelector.vue?vue&type=script&lang=js"
export * from "./ReceptionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports